import { all, call, SagaReturnType, takeLatest } from "redux-saga/effects";

import { loadSettings, updateSettings } from 'api/settings';
import { loadSettingsAction, updateSettingsAction } from './settings.actions';
import { ISettingsData } from '../../types/settings.types';

function* loadSettingsFlow(action: typeof loadSettingsAction.types.triggerAction) {
  try {
    const { data }: SagaReturnType<typeof loadSettings> = yield call(loadSettings);
    const settings: ISettingsData = data.reduce((acc, setting) => {
      acc[setting.id] = setting.value;
      return acc;
    }, {} as ISettingsData);
    yield call(loadSettingsAction.sagas.resolve, action, settings);
  } catch (e: any) {
    yield call(loadSettingsAction.sagas.reject, action, e?.message);
  }
}

function* updateSettingsFlow(action: typeof updateSettingsAction.types.triggerAction) {
  try {
    const { data }: SagaReturnType<typeof updateSettings> = yield call(updateSettings, action.payload);
    const settings: ISettingsData = Object.keys(data).reduce((acc, settingKey) => {
      acc[settingKey] = data[settingKey].value;
      return acc;
    }, {} as ISettingsData);
    yield call(updateSettingsAction.sagas.resolve, action, settings);
  } catch (e: any) {
    yield call(updateSettingsAction.sagas.reject, action, e?.message);
  }
}

export default function* settingsSaga() {
  yield all([
    takeLatest(loadSettingsAction.trigger, loadSettingsFlow),
    takeLatest(updateSettingsAction.trigger, updateSettingsFlow),
  ]);
}